import { graphBackFill, graphDefault, graphOutlinesUnfilled } from './';
export const graphNodeGroupClosed = (theme, parameters) => {
  const oulinesUnfilled = graphOutlinesUnfilled(theme, parameters);
  const defaultPattern = graphDefault(theme, parameters);
  const common = {
    fillColor: graphBackFill(theme, parameters).fillColor,
    transparency: 0,
    lineThickness: oulinesUnfilled.lineThickness
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          lineColor: defaultPattern.n3,
          textColor: defaultPattern.n3
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          lineColor: oulinesUnfilled.lineColor,
          textColor: oulinesUnfilled.lineColor
        };
      }
    default:
      {
        return {
          ...common,
          lineColor: defaultPattern.n_2,
          textColor: defaultPattern.n_2
        };
      }
  }
};
//# sourceMappingURL=graphNodeGroupClosed.js.map